/*
  Black November: Countdown, Phasenwechsel und Code-Kopieren.

  Daten kommen aus sections/g24-black-bar.liquid (window.g24BN, Phasen mit
  Start/Ende in Unix-Sekunden). Die Section setzt den ersten Zustand schon
  beim Rendern am <html>; hier wird er jede Sekunde nachgefuehrt:
  - alle [data-g24bn-timer] zaehlen auf das Ende der laufenden Phase
  - erreicht ein Countdown null, wird die Phase neu bestimmt; die Leiste
    wechselt ohne Neuladen auf die naechste Woche
  - nach der letzten Phase: data-g24bn-state="over", die CSS blendet dann
    Leiste, Badges und Rabattband aus und schaltet die Deal-Box auf "beendet"
  - Badge-Texte ([data-g24bn-badge-text]) folgen der Phase
*/
(function () {
  var D = window.g24BN;
  var pickFn = window.g24BNPick;
  if (!D || !pickFn) return;

  var root = document.documentElement;
  var current = null;

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function segments(ms) {
    var t = Math.max(0, Math.floor(ms / 1000));
    var d = Math.floor(t / 86400);
    var h = Math.floor((t % 86400) / 3600);
    var m = Math.floor((t % 3600) / 60);
    var s = t % 60;
    if (t >= 172800) return [[d, d === 1 ? 'Tag' : 'Tage'], [h, 'Std'], [m, 'Min']];
    return [[d * 24 + h, 'Std'], [m, 'Min'], [s, 'Sek']];
  }

  function paintTimers(endMs) {
    var segs = segments(endMs - Date.now());
    var timers = document.querySelectorAll('[data-g24bn-timer]');
    for (var i = 0; i < timers.length; i++) {
      var parts = timers[i].querySelectorAll('.g24bn-seg');
      for (var j = 0; j < parts.length && j < 3; j++) {
        var b = parts[j].querySelector('b');
        var u = parts[j].querySelector('small');
        var n = pad(segs[j][0]);
        if (b.textContent !== n) b.textContent = n;
        if (u.textContent !== segs[j][1]) u.textContent = segs[j][1];
      }
      timers[i].setAttribute('data-ready', '');
    }
  }

  function setText(el, txt) { if (el && el.textContent !== txt) el.textContent = txt; }

  function fillBar(p) {
    var bar = document.querySelector('[data-g24bn-bar]');
    if (!bar) return;
    bar.setAttribute('data-style', p.st || 'dark');
    setText(bar.querySelector('[data-f="k"]'), p.k || '');
    setText(bar.querySelector('[data-f="h"]'), p.h || '');
    setText(bar.querySelector('[data-f="c"]'), p.c || '');
    setText(bar.querySelector('[data-f="l"]'), p.l || '');
    var link = bar.querySelector('[data-f="u"]');
    if (link) {
      if (p.u) { link.setAttribute('href', p.u); link.hidden = false; } else { link.hidden = true; }
    }
    var code = bar.querySelector('[data-f="code"]');
    if (code) {
      if (p.code) {
        code.hidden = false;
        code.setAttribute('data-code', p.code);
        var ct = code.querySelector('[data-f="ct"]');
        if (ct) {
          // ct ist serverseitig escaped, nur <b>[code]</b> ist Markup
          var html = (p.ct || '').split('[code]').join(p.code.replace(/[&<>"]/g, ''));
          if (ct.innerHTML !== html) ct.innerHTML = html;
        }
      } else {
        code.hidden = true;
      }
    }
    bar.hidden = false;
  }

  function apply(pick) {
    root.setAttribute('data-g24bn-state', pick.state);
    if (pick.i > -1) {
      var p = D.phases[pick.i];
      root.setAttribute('data-g24bn-style', p.st || 'dark');
      root.setAttribute('data-g24bn-timer', p.t ? 'on' : 'off');
      fillBar(p);
      if (p.b) {
        var badges = document.querySelectorAll('[data-g24bn-badge-text]');
        for (var i = 0; i < badges.length; i++) setText(badges[i], p.b);
      }
    } else {
      root.removeAttribute('data-g24bn-style');
      var bar = document.querySelector('[data-g24bn-bar]');
      if (bar) bar.hidden = true;
    }
    current = pick;
  }

  function tick() {
    var pick = pickFn(D, Date.now());
    if (!current || pick.state !== current.state || pick.i !== current.i) apply(pick);
    if (pick.i > -1) paintTimers(D.phases[pick.i].e * 1000);
  }

  function copyCode(btn) {
    var code = btn.getAttribute('data-code');
    if (!code) return;
    var label = btn.querySelector('[data-f="cb"]');
    var done = function () {
      if (!label) return;
      label.textContent = 'Kopiert!';
      clearTimeout(btn._g24bnT);
      btn._g24bnT = setTimeout(function () { label.textContent = 'Kopieren'; }, 1800);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(done, done);
    } else {
      var ta = document.createElement('textarea');
      ta.value = code; ta.setAttribute('readonly', ''); ta.style.position = 'absolute'; ta.style.left = '-9999px';
      document.body.appendChild(ta); ta.select();
      try { document.execCommand('copy'); } catch (e) {}
      document.body.removeChild(ta); done();
    }
  }

  document.addEventListener('click', function (evt) {
    var btn = evt.target.closest && evt.target.closest('.g24bn-code');
    if (!btn) return;
    evt.preventDefault();
    copyCode(btn);
  });

  tick();
  setInterval(tick, 1000);
})();
